import * as React from "react";
import { Stack, styled, Tab, Typography } from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import AdronTypography from "./AdronTypography";
import {Direction} from "../_app/types";
import {PositionBehaviour} from "../store/slices/strategySlice";

interface TabItem {
	value?: string;
	label: string;
	icon?: React.ReactNode;
	color?: string;
}

interface Props {
	value: Direction | string | PositionBehaviour;
	onChange: (value: any) => void;
	paramList: string[] | TabItem[];
	label?: string;
	disabled?: boolean;
	postfix?: string;
	uppercase?: boolean;
}

const SwitchField = ({ value, onChange, paramList, label, disabled, postfix }: Props) => {
	const StyledTabs = styled(TabList)(({ theme }) => ({
		backgroundColor: theme.palette.grey[600],
		display: "flex",
		alignItems: "center",
		padding: "0 4px",
		maxHeight: "40px",
		minHeight: "40px",
		"& .MuiTab-root": {
			flex: "1 1 100%",
			maxWidth: "100% !important",
			minWidth: "auto !important",
			"&.Mui-selected.AdronSecondaryTabs": {
				color: theme.palette.text.primary,
				backgroundColor: theme.palette.secondary.main,
			},
		},
		"& .MuiTabs-flexContainer": {},
	}));

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		onChange(newValue);
	};

	return (
		<>
			{label && (
				<Typography
					style={{ opacity: "50%", marginBottom: "4px" }}
					variant="body2"
					color="textSecondary"
				>
					{label}
				</Typography>
			)}
			<TabContext value={value}>
				<StyledTabs
					style={{ borderRadius: 12, justifyContent: "center !important" }}
					onChange={handleChange}
				>
					{paramList &&
						paramList.map((value: string | TabItem, index) => {
							const isObject = typeof value === "object";
							const tabLabel = isObject ? value.label : value;
							const icon = isObject && value.icon ? value.icon : null;
							const color = isObject && value.color ? value.color : null;

							return (
								<Tab
									disabled={disabled}
									key={index}
									label={
										<>
											<Stack direction={"row"} alignItems={"center"} spacing={1}>
												{icon && (
													<AdronTypography
														value={`${tabLabel} ${postfix ? postfix : ""}`}
														color={color ? color : undefined}
														style={{ marginRight: 4 }}
													/>
												)}
												{icon}
												{!icon && (
													<AdronTypography
														value={`${tabLabel} ${postfix ? postfix : ""}`}
														color={color ? color : undefined}
													/>
												)}
											</Stack>
										</>
									}
									value={isObject ? (value.value ? value.value : value.label) : value}
									className="AdronSecondaryTabs"
								/>
							);
						})}
				</StyledTabs>
			</TabContext>
		</>
	);
}

export default SwitchField;
